import {Product} from './product.interface';
import {InputFieldComponent} from '../overlays/shopify-product-info/harry-potter-overlays/components/input-field/input-field-component';
import {SelectFieldComponent} from '../overlays/shopify-product-info/harry-potter-overlays/components/select-field/select-field-component';

export interface ShopifyProduct extends Product {
  options: Array<ShopifyOption>;
  variants: Array<EcommerceVariant>;
  input_fields: Array<ShopifyInputFields>;
  shop_name: string;
}

export interface EcommerceVariant {
  id: number | string;
  price: string;
  quantity: number;
  option1: string;
  option2: string;
  option3: string;
  inventory_quantity: number;
  buy_btn_url: string;
  isAutoSelected?: boolean;
  variant_id: string;
}

export interface ShopifyOption {
  id: number;
  product_id: number;
  name: string; // 'Size'
  position: number;
  values: Array<string>;
}

export interface ShopifyVariant extends EcommerceVariant {
  image_id: number;
  compare_at_price: string;
  merchandise_id: string;
  attributes?: {key: string; value: InputFieldComponent | SelectFieldComponent | string}[];
  per_order_limit?: number;
}

export enum IdealVariantTypes {
  MODEL = 'model', // used for products with multiple options, there are no documentation or explanation about this type
  CHILD = 'child', // used for products with multiple options e.g. size: 1, 2, 3, color: red, green, blue
  SIMPLE = 'simple' // used when products don't have any options to select e.g. product with one option
}

export interface IdealVariant extends EcommerceVariant {
  product_id: number;
  sku: string;
  variant_type: IdealVariantTypes;
}

interface ShopifyInputFields {
  name: string;
  identifier: string;
}
